import type { TranslationTag } from '@swf/core/types/i18n';

import type { BetSlipState } from '../../types/betSlip';

interface BetPlacementFailedPayload {
  errorMessage: TranslationTag;
  isAutoDismissibleError?: boolean;
}

const betPlacementFailed = (
  state: BetSlipState,
  { errorMessage, isAutoDismissibleError = false }: BetPlacementFailedPayload
): BetSlipState => ({
  ...state,
  errorMessage,
  isAutoDismissibleError,
  isLocked: false
});

export default betPlacementFailed;
